import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import login from '@/pages/PageLogin'
import PageHome from '@/pages/PageHome'
import PageTrucks from '@/pages/PageTruck'
import PageExpeditions from '@/pages/PageExpeditions'
import PageReceptions from '@/pages/PageReceptions'
import PageCriticLines from '@/pages/PageCriticLines'
import PageBi from '@/pages/PageBi'
import PageTruckSignUp from '@/pages/PageTruckSignUp'
import PageAddExpedition from '@/pages/PageAddExpedition'
import PageAddReception from '@/pages/PageAddReception'
import PageAddCriticalLine from '@/pages/PageAddCriticalLine'
import PageIndicators from '@/pages/PageIndicators'
import PageAlerts from '@/pages/PageAlerts'
import PageUsers from '@/pages/PageUsers'
import PageUser from '@/pages/PageUser'
import PageTruckSystem from '@/pages/PageTruckSystem'
import PageTaskList from '@/pages/PageTaskList'
import PageProduct from '@/pages/PageProduct'
import PageContact from '@/pages/PageContact'
import PageTermsConditions from '@/pages/PageTermsConditions'
import PagePrivacyPolicy from '@/pages/PagePrivacyPolicy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/terms-conditions',
      name: 'terms-conditions',
      component: PageTermsConditions
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PagePrivacyPolicy
    },
    {
      path: '/contact',
      name: 'contact',
      component: PageContact
    },
    {
      path: '/',
      name: 'product',
      component: PageProduct
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: PageHome,
      beforeEnter: requireAuth
    },
    {
      path: '/trucks',
      name: 'trucks',
      component: PageTrucks,
      beforeEnter: requireAuth
    },
    {
      path: '/expeditions',
      name: 'expeditions',
      component: PageExpeditions,
      beforeEnter: requireAuth
    },
    {
      path: '/receptions',
      name: 'receptions',
      component: PageReceptions,
      beforeEnter: requireAuth
    },
    {
      path: '/critical-lines',
      name: 'critical-lines',
      component: PageCriticLines,
      beforeEnter: requireAuth
    },
    {
      path: '/bi',
      name: 'bi',
      component: PageBi,
      beforeEnter: requireAuth
    },
    {
      path: '/truck/:id?',
      name: 'trucks-sign-up',
      component: PageTruckSignUp,
      beforeEnter: requireAuth
    },
    {
      path: '/expedition/:id?',
      name: 'add-expedition',
      component: PageAddExpedition,
      beforeEnter: requireAuth
    },
    {
      path: '/reception/:id?',
      name: 'add-reception',
      component: PageAddReception,
      beforeEnter: requireAuth
    },
    {
      path: '/critical-line/:id?',
      name: 'add-critical-line',
      component: PageAddCriticalLine,
      beforeEnter: requireAuth
    },
    {
      path: '/indicators',
      name: 'indicators',
      component: PageIndicators,
      beforeEnter: requireAuth
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: PageAlerts,
      beforeEnter: requireAuth
    },
    {
      path: '/users/',
      name: 'users',
      component: PageUsers,
      beforeEnter: requireAuth
    },
    {
      path: '/user/:id?',
      name: 'add-user',
      component: PageUser,
      beforeEnter: requireAuth
    },
    {
      path: '/truck-system',
      name: 'truck-system',
      component: PageTruckSystem,
      beforeEnter: requireAuth
    },
    {
      path: '/task-list/',
      name: 'task-list',
      component: PageTaskList,
      beforeEnter: requireAuth
    }
  ],
  scrollBehavior () {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 })
    })
  }
})
async function requireAuth (to, from, next) {
  if (!store.state.auth.authenticated) {
    next({
      path: '/login',
      query: Object.assign(to.query, { redirect: to.fullPath })
    })
  } else {
    var allows = await rolAllows(to, from, next)
    if (allows.go) {
      next()
    } else {
      next({
        path: allows.path,
        query: { redirect: to.fullPath }
      })
    }
  }
}
function rolAllows (to, from, next) {
  var getUserInfo = store._actions['auth/user'][0]
  var adminId = store.state.auth.admin.id
  var officeId = store.state.auth.office.id
  var kioskId = store.state.auth.kiosk.id
  var kioskReceptionsId = store.state.auth.kioskReceptions.id
  var clientId = store.state.auth.client.id
  var forkliftId = store.state.auth.forklift.id
  var warehouseId = store.state.auth.warehouseResp.id
  var plannerTRWId = store.state.auth.plannerTrw.id
  var oficinaJuanCarlosId = store.state.auth.oficinaJuanCarlos.id
  var carretillerosId = store.state.auth.carretilleros.id
  var providerId = store.state.auth.provider.id
  var guardiaId = store.state.auth.guardia.id
  var truckAccessId = store.state.auth.truckAccess.id
  return getUserInfo().then(() => {
    var outPut = {go: true, path: '/dashboard'}
    var roles = store.state.auth.userData.roles ? store.state.auth.userData.roles.map(x => x.id) : []
    // if admin lets it go
    // if (to.name === 'dashboard' && roles.indexOf(kioskId) < 0 && roles.indexOf(kioskReceptionsId) < 0) {
    // outPut.go = true
    if (roles.indexOf(adminId) >= 0 || roles.indexOf(officeId) >= 0 || roles.indexOf(warehouseId) >= 0) {
      outPut.go = true
    } else if (roles.indexOf(truckAccessId) >= 0) {
      if (['truck-system'].indexOf(to.name) >= 0) {
        outPut.go = true
      } else {
        outPut = {go: false, path: '/truck-system'}
      }
    } else if (roles.indexOf(adminId) >= 0 || roles.indexOf(officeId) >= 0 || roles.indexOf(warehouseId) >= 0) {
      outPut.go = true
    // if kiosko only allow listes
    } else if (roles.indexOf(kioskId) >= 0) {
      if (['expeditions', 'critical-lines'].indexOf(to.name) >= 0) {
        outPut.go = true
      } else {
        outPut = {go: false, path: '/expeditions'}
      }
    } else if (roles.indexOf(kioskReceptionsId) >= 0) {
      if (['receptions'].indexOf(to.name) >= 0) {
        outPut.go = true
      } else {
        outPut = {go: false, path: '/receptions'}
      }
    } else if (roles.indexOf(plannerTRWId) >= 0 || roles.indexOf(oficinaJuanCarlosId) >= 0 || roles.indexOf(carretillerosId) >= 0) {
      if (['expeditions', 'add-expedition', 'receptions', 'add-reception', 'critical-lines', 'add-critical-line'].indexOf(to.name) >= 0 || ((to.name === 'bi') && roles.indexOf(oficinaJuanCarlosId) >= 0)) {
        outPut.go = true
      } else {
        outPut = {go: false, path: '/expeditions'}
      }
    } else if (roles.indexOf(guardiaId) >= 0) {
      if (['trucks', 'trucks-sign-up'].indexOf(to.name) >= 0) {
        outPut.go = true
      } else {
        outPut = {go: false, path: '/trucks'}
      }
    } else if (roles.indexOf(providerId) >= 0) {
      if (['receptions', 'add-reception'].indexOf(to.name) >= 0) {
        outPut.go = true
      } else {
        outPut = {go: false, path: '/receptions'}
      }
    } else {
      switch (to.name) {
        case 'bi':
          outPut = {go: false, path: '/dashboard'}
          break
        case 'trucks':
          if (roles.indexOf(clientId) >= 0 || roles.indexOf(forkliftId) >= 0) {
            outPut = {go: false, path: '/dashboard'}
          }
          break
        case 'trucks-sign-up':
          if (!to.params || !to.params.id || roles.indexOf(forkliftId) >= 0) {
            outPut = {go: false, path: '/trucks'}
          } else {
            if (!roles.indexOf(clientId) >= 0) {
              outPut.go = true
            }
          }
          break
        case 'add-expedition':
          if (!to.params || !to.params.id) {
            outPut = {go: false, path: '/expeditions'}
          } else {
            outPut.go = true
          }
          break
        case 'add-reception':
          if (!to.params || !to.params.id) {
            outPut = {go: false, path: '/receptions'}
          } else {
            outPut.go = true
          }
          break
        case 'indicators':
          outPut = {go: false, path: '/dashboard'}
      }
    }
    return outPut
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js